// src/api/bookSearch.js

// // 환경 변수 직접 확인
// const KAKAO_API_KEY = 'KakaoAK 0540ea1b773afa38314d580989ae46de';

// // API 키 디버깅 정보 추가
// console.log('KAKAO_API_KEY:', KAKAO_API_KEY);
// console.log('process.env:', process.env);

// if (!KAKAO_API_KEY) {
//   console.error('카카오 API 키가 설정되지 않았습니다.');
//   throw new Error('카카오 API 키가 설정되지 않았습니다.');
// }

// const makeKakaoRequest = async (url) => {
//   try {
//     console.log('API 요청 URL:', url);
//     console.log('사용되는 API 키:', KAKAO_API_KEY);

//     const response = await fetch(url, {
//       headers: {
//         Authorization: KAKAO_API_KEY,
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`카카오 API 요청 실패: ${response.status} ${response.statusText}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error('API 요청 중 오류 발생:', error);
//     throw error;
//   }
// };

// Aladin Open API 키 (참고용, 실제 호출은 프록시에서 처리)
const ALADIN_TTB_KEY = 'ttbfkdleh71900117003';
const ALADIN_BASE_URL = 'https://www.aladin.co.kr/ttb/api/ItemSearch.aspx';

// 알라딘 응답 파싱 함수
function parseAladinBook(item) {
  return {
    title: item.title || '',
    authors: item.author ? item.author.split(';').map(a => a.trim()).filter(Boolean) : [],
    isbn: item.isbn13 || '',
    thumbnail: item.cover || '',
    publisher: item.publisher || '',
    datetime: item.pubDate || '',
    contents: item.description || '',
  };
}

// 알라딘 프록시 공통 fetch 함수 (응답 타입 확인 포함)
async function fetchAladinProxy(url) {
  try {
    const response = await fetch(url);
    const contentType = response.headers.get("content-type");

    if (!response.ok) {
      throw new Error(`Aladin 프록시 API 요청 실패: ${response.status}`);
    }

    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      console.error("비정상 응답 (HTML 가능성):", text.slice(0, 300));
      throw new Error("알라딘 API에서 JSON이 아닌 응답을 반환했습니다.");
    }

    return await response.json();
  } catch (error) {
    console.error("알라딘 프록시 fetch 오류:", error);
    throw error;
  }
}

// 키워드 기반 책 검색
export async function searchBooksByKeyword(keyword) {
  if (!keyword || keyword.trim() === '') return [];

  const url = `/aladinSearch?query=${encodeURIComponent(keyword)}&type=Title`;

  try {
    const data = await fetchAladinProxy(url);
    if (!data.item || !Array.isArray(data.item)) return [];
    return data.item.map(parseAladinBook);
  } catch (error) {
    console.error("책 검색(알라딘 프록시) 중 오류 발생:", error);
    throw error;
  }
}

// ISBN 기반 단일 책 검색
export async function searchBookByISBN(isbn) {
  if (!isbn || isbn.trim() === '') return null;

  const url = `/aladinSearch?query=${encodeURIComponent(isbn)}&type=ISBN`;

  try {
    const data = await fetchAladinProxy(url);
    if (!data.item || data.item.length === 0) return null;
    return parseAladinBook(data.item[0]);
  } catch (error) {
    console.error("ISBN 검색(알라딘 프록시) 중 오류 발생:", error);
    throw error;
  }
}